import { Colors, flags } from '@sigma-frontend-libs/commons'

import squircle from '@/components/icon/squircle'

function renderFlag(h) {
  return h(
    'div',
    {
      class: 'flag',
      style: this.$_style,
      domProps: {
        innerHTML: flags[this.value]
      },
      directives: this.$_directives,
      slot: 'icon'
    }
  )
}

function renderSquircle(h) {
  return h(
    squircle,
    {
      props: {
        color: Colors.grey,
        tooltip: this.$_tooltip
      }
    },
    [ renderFlag.call(this, h) ]
  )
}

export default function(h) {
  if (this.squircle) {
    return renderSquircle.call(this, h)
  }

  return renderFlag.call(this, h)
}
